"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const schedule_controller_1 = require("@/controllers/schedule-controller");
const FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), audio[controls], video[controls]';
let TabPanel = class TabPanel extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        /** @internal 선택 값을 소유한 mm-tab-list가 채운다. */
        this.active = false;
        this.tabStopFrame = new schedule_controller_1.ScheduleController(this, () => this.syncTabStop());
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'tabpanel');
    }
    render() {
        return (0, lit_1.html) `
      <slot @slotchange=${this.handleSlotChange}></slot>
    `;
    }
    // 내부에 포커스 가능한 요소가 없을 때만 패널 자체를 탭 스톱으로 만든다 (ARIA APG tabpanel).
    handleSlotChange() {
        this.tabStopFrame.request();
    }
    syncTabStop() {
        this.tabIndex = this.hasFocusableContent(this) ? -1 : 0;
    }
    hasFocusableContent(root) {
        for (const element of root.querySelectorAll('*')) {
            if (element.matches(FOCUSABLE_SELECTOR))
                return true;
            if (element.shadowRoot && this.hasFocusableContent(element.shadowRoot))
                return true;
        }
        return false;
    }
};
TabPanel.styles = (0, lit_1.css) `
    :host {
      display: none;
    }
    :host([active]) {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TabPanel.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], TabPanel.prototype, "active", void 0);
TabPanel = __decorate([
    (0, decorators_js_1.customElement)('mm-tab-panel')
], TabPanel);
exports.TabPanel = TabPanel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFiLXBhbmVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGFiLXBhbmVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsMkVBQXNFO0FBRXRFLE1BQU0sa0JBQWtCLEdBQ3RCLDZHQUE2RyxDQUFBO0FBR3hHLElBQU0sUUFBUSxHQUFkLE1BQU0sUUFBUyxTQUFRLGdCQUFVO0lBQWpDOztRQVN1QixVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ3RDLDRDQUE0QztRQUNBLFdBQU0sR0FBRyxLQUFLLENBQUE7UUFDbEQsaUJBQVksR0FBRyxJQUFJLHdDQUFrQixDQUFDLElBQUksRUFBRSxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUMsQ0FBQTtJQTZCL0UsQ0FBQztJQTNCQyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxVQUFVLENBQUMsQ0FBQTtJQUN2QyxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7MEJBQ1csSUFBSSxDQUFDLGdCQUFnQjtLQUMxQyxDQUFBO0lBQ0gsQ0FBQztJQUVELCtEQUErRDtJQUN2RCxnQkFBZ0I7UUFDdEIsSUFBSSxDQUFDLFlBQVksQ0FBQyxPQUFPLEVBQUUsQ0FBQTtJQUM3QixDQUFDO0lBRU8sV0FBVztRQUNqQixJQUFJLENBQUMsUUFBUSxHQUFHLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUN6RCxDQUFDO0lBRU8sbUJBQW1CLENBQUMsSUFBZ0I7UUFDMUMsS0FBSyxNQUFNLE9BQU8sSUFBSSxJQUFJLENBQUMsZ0JBQWdCLENBQUMsR0FBRyxDQUFDLEVBQUU7WUFDaEQsSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDLGtCQUFrQixDQUFDO2dCQUFFLE9BQU8sSUFBSSxDQUFBO1lBQ3BELElBQUksT0FBTyxDQUFDLFVBQVUsSUFBSSxJQUFJLENBQUMsbUJBQW1CLENBQUMsT0FBTyxDQUFDLFVBQVUsQ0FBQztnQkFBRSxPQUFPLElBQUksQ0FBQTtTQUNwRjtRQUNELE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQzs7QUF2Q00sZUFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7O0dBT2xCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFXO0FBRU07SUFBM0MsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7d0NBQWU7QUFYL0MsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsY0FBYyxDQUFDO0dBQ2pCLFFBQVEsQ0F5Q3BCO0FBekNZLDRCQUFRIn0=